/* LoginSignupForm auto-generated by npm run generator */
import { Button, ButtonProps, CircularProgress, FormHelperText, makeStyles, Theme, Typography } from "@material-ui/core"
import clsx from "clsx"
import { useLoading } from "hooks/useLoading"
import { observer } from "mobx-react"
import React from "react"
import { useRootClasses } from "style"

export const PortalSubmitButton: React.FC<ButtonProps> = ({ children, type, ...rest }) => (
    <Button type={type ?? "submit"} form="portalForm" fullWidth {...rest}>
        {children}
    </Button>
)

export interface PortalFormProps {
    title: string
    subtitle: string
    form: JSX.Element
    buttons: JSX.Element
    buttonAction: () => Promise<void>
    closeButton?: JSX.Element
}

const useStyles = makeStyles((theme: Theme) => ({
    portalForm: {
        maxWidth: 600,
        margin: "0 auto",
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 0px 2px rgba(0, 0, 0, 0.14)",
        borderRadius: 24,
        padding: theme.spacing(4),
        textAlign: "center",
        minHeight: 440,
        display: "grid",
        justifyItems: "center",
        gridGap: theme.spacing(2),
        gridTemplateRows: "auto 1fr auto",
    },
    header: {
        display: "grid",
        gridGap: theme.spacing(2),
    },
    form: {
        display: "grid",
        width: 283,
        alignContent: "center",
        gridGap: theme.spacing(3),
    },
    buttons: {
        width: "100%",
        display: "grid",
        gridGap: theme.spacing(10),
        gridAutoFlow: "column",
        justifyContent: "center",
        gridAutoColumns: "1fr",
        justifyItems: "center",
        direction: "rtl",
    },
}))

const PortalForm: React.FC<PortalFormProps> = ({ title, subtitle: subTitle, buttonAction, form, buttons, closeButton }) => {
    const classes = useStyles()
    const { loading, error, action } = useLoading()
    const rc = useRootClasses()

    return (
        <div className={clsx(classes.portalForm, closeButton ? rc.pt9 : "")}>
            {closeButton}
            <div className={classes.header}>
                <Typography variant="h2">{title}</Typography>
                <Typography variant="h6">{subTitle}</Typography>
            </div>
            <form
                className={classes.form}
                onSubmit={async (e) => {
                    e.preventDefault()
                    await action(buttonAction)
                }}
                id="portalForm"
            >
                {form}
                <FormHelperText error>{error}</FormHelperText>
            </form>
            <div className={classes.buttons}>{loading ? <CircularProgress /> : buttons}</div>
        </div>
    )
}

export default observer(PortalForm)
